import { FC, useEffect, useRef } from "react";
import s from "./RenderPreview.module.scss";
import { handleImage } from "../../api/renderAndLoadImage";
import { CloseIcon } from "../../../assets/svg/CloseIcon";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { getUser } from "../../../redux/reducers/user/userSelectors";
import { EViewType, useURLRouting } from "../../../utils/hooks/useURLRouting";
import { getHistoryListThunk } from "../../../redux/reducers/history/historyThunks";
import { changeShowModal } from "../../../redux/reducers/app/appReducer";

type RenderPreviewT = {
  closeFunc: any;
  img: any;
};
export const RenderPreview: FC<RenderPreviewT> = ({ ...props }) => {
  const { closeFunc, img } = props;
  const dispatch = useAppDispatch();
  const wrapperRef: any = useRef(null);
  const user = useAppSelector(getUser());
  const userID =  user && user.id >= 0 && user.id;
  const { currentView } = useURLRouting();

  function clickHandler(type: "preview" | "download") {
    if (type === "preview") {
      dispatch(
        changeShowModal({
          nameModal: "fullScreenPreview",
          stateModal: true,
          otherParams: { img },
        })
      );
    } else {
      handleImage({ base64Image: img, type });
    }
  }

  // Update history list if history sidebar is open
  useEffect(() => {
    const getHistoryList = async (id:number) => {
      await dispatch(getHistoryListThunk({id})).unwrap();
    }

    if (userID && currentView.type === EViewType.History) {
      getHistoryList(userID);
    }
  }, [img])

  useEffect(() => {
    const handleClickOutside =
      (wrapperRef: any, closeFunc: any) => (event: any) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          closeFunc();
        }
      };
    document.addEventListener(
      "mousedown",
      handleClickOutside(wrapperRef, closeFunc)
    );
    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside(wrapperRef, closeFunc)
      );
    };
  }, [wrapperRef]);
  //@ts-ignore

  return (
    <div className={s.wrapper} ref={wrapperRef}>
      <div className={s.head}>
        <span>Render</span>
        <div className={s.close} onClick={closeFunc}>
          <CloseIcon />
        </div>
      </div>
      <div className={s.img}>
        <img src={`${img}`} alt="" />
      </div>
      <div className={s.footer}>
        <div className={s.timer}>
          {`Rendering time: 
          ${
            //@ts-ignore
            window.timer.m
          }m 
          ${
            //@ts-ignore
            window.timer.s
          }sec
          `}
        </div>
        <div className={s.btns}>
          <button className={s.preview} onClick={() => clickHandler("preview")}>
            Preview
          </button>
          <button className={s.download} onClick={() => clickHandler("download")}>
            Download
          </button>

        </div>
      </div>
    </div>
  );
};
